import { Helmet } from "react-helmet";
import ContactLayout from '../section/contact/contact-layout';

const ContactPage = () => {
    <Helmet>
        <title>Contact Digital Tourism | Connect With Our Travel-Tech Team</title>
        <meta name="description" content="Get in touch with Digital Tourism for inquiries, partnerships, support, or platform information. We’re here to help you explore digital solutions for tourism industry." />
        <meta name="keywords" content="contact Digital Tourism, travel tech support Sri Lanka, tourism inquiries, travel platform help" />
    </Helmet>

    return (
        <>
            <ContactLayout />
        </>
    );
}

export default ContactPage;